/**
 * WebView (React Native) 側にセッション切れを通知する。
 * ReactNativeWebView が存在する場合に postMessage を送り true を返す。
 * 存在しない場合は何もせず false を返す。
 */
export const notifySessionExpirationToRNApp = (): boolean => {
  if (typeof window === 'undefined') {
    return false;
  }
  const reactNativeWebView = (window as any).ReactNativeWebView;
  if (typeof reactNativeWebView?.postMessage !== 'function') {
    return false;
  }
  reactNativeWebView.postMessage(
    JSON.stringify({redirectToLoginOnSessionExpiration: true}),
  );
  return true;
};
